import { AspectRatio } from '@styled-icons/material';
import { MediaEmbedElement } from '@typedream/core';
import { setNodes } from '@udecode/plate-core';
import classNames from 'classnames';
import { memo } from 'react';
import { useTPlateEditorRef } from '../../../plate';
import { getSelectedElementEntry } from '../../../plugins/elementSelection';
import { useDreamEditorStore } from '../../../plugins/store';
import styles from '../SideToolbar.module.css';

function EmbedAspectRatio() {
  const editor = useTPlateEditorRef();

  const keepAspectRatio = useDreamEditorStore(
    () => !!getSelectedElementEntry<MediaEmbedElement>(editor)?.[0]?.keep_aspect_ratio,
  );

  const toggleKeepAspectRatio = () => {
    const path = getSelectedElementEntry(editor)?.[1];
    setNodes(editor, { keep_aspect_ratio: !keepAspectRatio }, { at: path });
  };

  return (
    <div className={styles.section}>
      <label className={styles.subLabel} htmlFor="#">
        Keep Aspect Ratio
      </label>
      <div className={styles.menuGroup}>
        <button
          className={classNames(styles.menuItem, {
            [styles.active]: keepAspectRatio,
          })}
          type="button"
          onClick={toggleKeepAspectRatio}
        >
          <div className="p-1">
            <AspectRatio size={16} />
          </div>
        </button>
      </div>
    </div>
  );
}

export default memo(EmbedAspectRatio);
